/**
 * This file is automatically generated using generator/actions/generate-action.ts.
 * Do NOT modify this file by hand.
 */

import { AxiosInstance, AxiosRequestConfig } from 'axios';
import { SweetPath } from 'sweet-path';

import { GetReservationDetailPathParameters } from 'api/actions/get-reservation-detail/get-reservation-detail-path-parameters';
import { GetReservationDetailResponse } from 'api/actions/get-reservation-detail/get-reservation-detail-response';

type GetReservationDetailQueryParameters = Record<string, any>;

/**
 * The path of the GetReservationDetail action.
 */
export const getReservationDetailActionPath = new SweetPath<keyof GetReservationDetailPathParameters>(
  '/reservations/{reservationId}',
  { path: '{param}' }
);

/**
 * Creates a contextualized GetReservationDetail actions.
 */
export default function createGetReservationDetailAction(axios: AxiosInstance) {
  return function getReservationDetailAction({
    headers = {},
    parameters,
    query = {},
  }: {
    headers?: AxiosRequestConfig<any>['headers'];
    parameters: GetReservationDetailPathParameters;
    query?: GetReservationDetailQueryParameters;
  }) {
    const path = getReservationDetailActionPath.insert(parameters);

    return axios.get<GetReservationDetailResponse, GetReservationDetailResponse>(path, { params: query, headers });
  };
}
